import {BrowserRouter,Route, Switch} from 'react-router-dom'
import React, { useEffect } from 'react';
import './App.css';
import Login from './pages/login/login'
import Regist from './pages/regist/regist'
import Reset from './pages/reset/reset'
import Index from './pages/index/index'
// import Account from './pages/user/account'
import {logPageView} from './pages/utils/functionUtils'

const supportedTargets = ['port', 'val', 'opt'];
const appTarget = supportedTargets.includes(process.env.REACT_APP_TARGET)
  ? process.env.REACT_APP_TARGET
  : 'opt';

function App() {
  useEffect(() => {
    logPageView();
  }, []);
  const basename = process.env.NODE_ENV === 'development' ? '/' : `/${appTarget}`;
  return (
      <BrowserRouter  basename={basename}>
        <Switch>
            <Route path='/login' component={Login}></Route>
            <Route path='/regist' component={Regist}></Route>
            <Route path='/reset' component={Reset}></Route>
            <Route path='/' component={Index} />
        </Switch>                
      </BrowserRouter >
  );
}

export default App;
